// eslint-disable-next-line no-restricted-syntax
export enum UserType {
  EMPLOYEE = "EMPLOYEE",
  WORKPLACE_USER = "WORKPLACE_USER",
  WORKER = "WORKER",
}
